import { Box, Stack, Typography, useTheme } from "@mui/material";
import { SxProps, Theme } from "@mui/material/styles";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { ClusterData } from "../../queries/community.types";
import { useCommunityClusterStore, useCurrentCommunityCluster } from "../../stores";
import SelectCst from "../InputCst/SelectCst";

export function CommunityClusterSelect({ predicate = () => true, sx }:{ predicate?: (cluster:ClusterData) => boolean, sx?: SxProps<Theme> }) {
  const theme = useTheme();
  const { t } = useTranslation();
  const { isLoading, availableClusters: clusters, currentCluster } = useCurrentCommunityCluster();
  const { setCurrentCluster } = useCommunityClusterStore();

  useEffect(() => {
    if(predicate && (!currentCluster || !predicate(currentCluster))) {
      setCurrentCluster(clusters.find(predicate));
    }
  }, [predicate, currentCluster, clusters, setCurrentCluster]);

  if(!isLoading && clusters.length > 1) {
    const options = clusters.filter(predicate).map((cluster) => ({
      label: cluster.name,
      value: cluster.id
    }));

    return (
      <Stack direction={ "row" } alignItems={ "center" } gap={ "16px" } sx={ sx }>
        <Typography 
          fontSize={ "0.875rem" }
          lineHeight={ "1.0938rem" }
          color={ theme.customColors.textPrimary }
        >
          { t("select_community") }
        </Typography>
        <Box sx={ { 
          height: "2rem",
          ".MuiOutlinedInput-input": {  
            padding: "5px 15px"
          } 
        } }>
          <SelectCst
            name="community-cluster"
            options={ options }
            value={ currentCluster?.id?.toString() ?? "" }
            onChange={ (e) => {
              const selected = clusters.find((c) => c.id === Number(e.target.value));
              setCurrentCluster(selected);
            } }
            sxTypography={ {
              fontSize: "0.75rem",
              fontWeight: 600,
              lineHeight: "1.5rem",
              color: theme.customColors.textPrimary
            } }
          />
        </Box>
      </Stack>
    );
  }

  return <></>;
}


